import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';

import { getCurrentAdStateSelectedComponents, getFontWeights, getActiveFonts } from 'Selectors';
import { fetchFontHTML } from 'Actions/fontActions';
import { setSelectBoxOpen } from 'Actions/UIActions';
import { setWeightAndApplyStyle } from 'Actions/settingsActions';
import Select from 'SharedComponents/WveInputs/style';

class WveInputFontWeight extends Component {
  componentWillReceiveProps(nextProps) {
    const { selectedComponents, fontWeights } = nextProps;
    const fontWeightId = selectedComponents.first().settings.get('WFPWeightId');
    const oldFontWeightId = this.props.selectedComponents.first().settings.get('WFPWeightId');
    if (fontWeightId !== oldFontWeightId) {
      const fontId = selectedComponents.first().settings.get('WFPFontId');
      const displayWeights = fontWeights.get(fontId);
      const fontWeight = (displayWeights) ? displayWeights.find(w => w.id === fontWeightId) : null;
      this.setValue(fontWeight);
    }
  }
  setValue = (weight) => {
    const { setWeightAndApplyStyle } = this.props; // eslint-disable-line no-shadow
    const {
      activeFonts,
      fetchFontHTML, // eslint-disable-line no-shadow
    } = this.props;
    if (weight === null) {
      setWeightAndApplyStyle(weight);
      return;
    }
    if (!activeFonts.find(font => font.id === weight.id)) {  // eslint-disable-line no-undef
      fetchFontHTML(weight.id)
        .then(() => {
          setWeightAndApplyStyle(weight);
        });
    } else {
      setWeightAndApplyStyle(weight);
    }
  };
  handleOpen = () => {
    const { setSelectBoxOpen } = this.props; // eslint-disable-line no-shadow
    setSelectBoxOpen(true);
  };
  handleClose = () => {
    const { setSelectBoxOpen } = this.props; // eslint-disable-line no-shadow
    setSelectBoxOpen(false);
  };
  renderFontOption = font => <option value={font.family}>{font.name}</option>;
  renderValue = font => font.name;
  render() {
    const { fontWeights, selectedComponents } = this.props;
    const fontId = selectedComponents.first().settings.get('WFPFontId');
    const fontWeightId = selectedComponents.first().settings.get('WFPWeightId');
    const displayWeights = fontWeights.get(fontId);
    const fontWeight = (displayWeights) ? displayWeights.find(w => w.id === fontWeightId) : null;
    const weightsArray = (displayWeights) ? displayWeights.toJS() : [];
    return (
      <div
        className="wve-form-item wve-form-item-long"
      >
        <Select
          options={weightsArray}
          onChange={this.setValue}
          optionRenderer={this.renderFontOption}
          value={fontWeight}
          valueRenderer={this.renderValue}
          placeholder={'Select a weight...'}
          clearable={false}
          backspaceRemoves={false}
          searchable={false}
          onOpen={this.handleOpen}
          onClose={this.handleClose}
        />
      </div>
    );
  }
}

WveInputFontWeight.propTypes = {
  fontWeights: PropTypes.instanceOf(List).isRequired,
  setWeightAndApplyStyle: PropTypes.func,
  selectedComponents: PropTypes.instanceOf(List).isRequired,
  setSelectBoxOpen: PropTypes.func,
  fetchFontHTML: PropTypes.func,
  activeFonts: PropTypes.instanceOf(List),
};

WveInputFontWeight.defaultProps = {
  setWeightAndApplyStyle: () => {},
  setSelectBoxOpen: () => {},
  fetchFontHTML: () => {},
  activeFonts: new List(),
};


const mapStateToProps = state => ({
  fontWeights: getFontWeights(state),
  selectedComponents: getCurrentAdStateSelectedComponents(state),
  activeFonts: getActiveFonts(state),
});


const mapDispatchToProps = (dispatch) => {
  return {
    setSelectBoxOpen: (open) => {
      dispatch(setSelectBoxOpen(open));
    },
    setWeightAndApplyStyle: (weight) => {
      dispatch(setWeightAndApplyStyle(weight));
    },
    fetchFontHTML: fontId => dispatch(fetchFontHTML(fontId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WveInputFontWeight);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputFontWeight/WveInputFontWeight.jsx